export default __webpack_public_path__ + "static/media/ic-communityproject.d195d704.svg";